<template lang="pug">
el-dialog(v-dialogDrag, title="新建自定义页面", :visible.sync="dataDialog", width="400px", :before-close="handleClose")
  el-form(ref="form", :model="form", label-width="100px", size="small", label-position="top", :rules="rules")
    el-form-item(label="自定义页面名称", prop="pageName")
      el-input(v-model="form.pageName", clearable)
    el-form-item(label="自定义页面编号", prop="pageCode")
      el-input(v-model="form.pageCode", clearable)
    el-form-item(label="自定义页面描述", prop="remark")
      el-input(v-model="form.remark", type="textarea")
  div(slot="footer")
    el-button(@click="handleClose", size="small") 取 消
    el-button(type="primary", @click="onSubmit", size="small") 确 定
</template>

<script>
import { dyn_custom_page_saveOrUpdate } from "@/CommonDP/service/metadata-custom-page-service.js";
export default {
  data() {
    return {
      type: "", // "add" :新增；"edit":编辑
      dataDialog: false,
      metaList: [], //
      form: {
        groupId: "",
        pageCode: "",
        pageName: "",
        pageId: "",
        remark: ""
      },
      rules: {
        pageName: { required: true, message: " " },
        pageCode: { required: true, message: " " }
      }
    };
  },
  methods: {
    async init(data) {
      this.dataDialog = true;
      this.$refs.form?.clearValidate?.();
      this.form = { ...data };
      await this.$nextTick();
    },
    handleClose() {
      this.dataDialog = false;
    },

    async onSubmit() {
      const params = { ...this.form };
      try {
        await dyn_custom_page_saveOrUpdate(params);
        this.$success("添加成功!");
        this.$emit("initTree");
        this.form = {};
      } catch (error) {
        console.log(error);
      }
      this.dataDialog = false;
    }
  }
};
</script>

<style lang="scss" scoped></style>

